<template>
    <div class="categories mb-5">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <b-container class="pt-5 pb-5 categories">
            <h2 class="mb-5 categories-title">Categorias</h2>
            <vue-masonry-wall :items="categories" :options="{width: 300, padding: 12}" :ssr="{columns: 2}">
                <template v-slot:default="{item}">
                    <div class="item">
                        <nuxt-link :to="'/categoria/' + item.alias">
                            {{ item.name }}
                        </nuxt-link>
                        <template v-if="item.subitems.length">
                            <button type="button" class="control-collapse" @click="visibles[item.code] = !visibles[item.code]">
                                <template v-if="visibles[item.code]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="3">
                                        <rect width="14" height="3"/>
                                    </svg>
                                </template>
                                <template v-else>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" class="call-center-accordion-btn-icon">
                                        <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/>
                                    </svg>
                                </template>
                            </button>
                            <div class="expand pl-2">
                                <b-collapse v-model="visibles[item.code]">
                                    <ul class="py-1">
                                        <li class="mb-2" v-for="subcategory in item.subitems" :key="subcategory.code">
                                            <nuxt-link :to="'/categoria/' + item.alias + '/' + subcategory.alias">
                                                {{ subcategory.name }}
                                            </nuxt-link>
                                            <template v-if="subcategory.subitems.length">
                                                <button type="button" class="control-collapse" @click="visibles[subcategory.code] = !visibles[subcategory.code]">
                                                    <template v-if="visibles[subcategory.code]">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="3">
                                                            <rect width="14" height="3"/>
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" class="call-center-accordion-btn-icon">
                                                            <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/>
                                                        </svg>
                                                    </template>
                                                </button>
                                                <div class="expand pl-2">
                                                    <b-collapse v-model="visibles[subcategory.code]">
                                                        <ul class="py-1">
                                                            <li class="mb-2" v-for="subcategory2 in subcategory.subitems" :key="subcategory2.code">
                                                                <nuxt-link :to="'/categoria/' + item.alias + '/' + subcategory.alias + '/' + subcategory2.alias">
                                                                    {{ subcategory2.name }}
                                                                </nuxt-link>
                                                            </li>
                                                        </ul>
                                                    </b-collapse>
                                                </div>
                                            </template>
                                        </li>
                                    </ul>
                                </b-collapse>
                            </div>
                        </template>
                    </div>
                </template>
            </vue-masonry-wall>
        </b-container>
    </div>
</template>
<script>
    import Breadcrumb from '~/components/Breadcrumb';
    import utils from "~/mixins/utils";
    import VueMasonryWall from "vue-masonry-wall";

    export default {
        mixins: [
            utils
        ],
        components: {
            Breadcrumb,
            VueMasonryWall
        },
        head() {
            return {
                title: this.page_title
            }
        },
        data() {
            return {
                categories: [],
                visibles: {}
            }
        },
        computed: {
            breadcrumb() {
                let link = '/categoria';
                let breadcrumb = [
                    {
                        name: 'Home',
                        link: '/'
                    }
                ];
                breadcrumb.push({
                    name: this.page_title,
                    link: null
                })
                return breadcrumb;
            },
            page_title() {
                try {
                    return 'Categorias'
                } catch (e) {
                    console.error(e)
                }
                return ''
            }
        },
        async fetch() {
            this.categories = this.$store.state.categories
        }
    }
</script>
